import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ComponentsModule } from "../../components/form-components.module";
import { ForgotPasswordComponent } from "./forgot-password.component";
import { HttpService } from "src/providers/http.service";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [ ComponentsModule, RouterModule ],
    declarations: [ForgotPasswordComponent],
    providers: [ HttpService ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})

export class ForgotPasswordModule {}